export default "/_next/static/images/solutions--marketing-0fc6ec0aeab50485489ad1f6da1a1e5d.svg";